import { combineReducers } from 'redux';
import { userReducer } from './reducers/user';
import { programReducer } from './reducers/program-reducer';
import { modelReducer } from './reducers/model-reducer';
import { buReducer } from './business-units/business-units-reducer';
import { ppReducer } from './product-platforms/product-platforms-reducer';

export default combineReducers({
    userReducer,
    programReducer,
    modelReducer,
    buReducer,
    ppReducer,
});